import gql from 'graphql-tag';

export const RECURRING_PLANTINGS_QUERY = gql`
  query RecurringPlantingsHome {
    recurring_plantings(
      orderBy: [{ name: "recurring_planting.recurring_planting_name", direction: "asc" }]
    ) {
      edges {
        node {
          id
          crop {
            id
            crop_name
          }
          recurring_planting_name
          status
          recurring_start_time
          recurring_end_time
          recurring_options {
            exceptions
            frequencyGroups {
              frequencyType
              frequencies
            }
          }
        }
      }
    }
  }
`;
